import { ComponentProps } from 'react'

import moment from 'moment'

import i18n from 'modules/core/lib/i18n'

import { DateTimeSelector } from 'modules/performance_process/components/common/DateTimeSelector'

export const DeadlinePicker: React.FC<{
  date: ComponentProps<typeof DateTimeSelector>['date']
  minDate?: Date
  maxDate?: Date
  onChange: ComponentProps<typeof DateTimeSelector>['onChange']
  readonly?: boolean
  error?: string
  restrictToFutureTimes?: boolean
}> = ({
  date,
  minDate,
  maxDate,
  onChange,
  error,
  readonly = false,
  restrictToFutureTimes = false,
}) => (
  <DateTimeSelector
    placeholder={i18n.t('performance_process.reviews.timeline_section.date_placeholder')}
    aria-label={i18n.t('performance_process.reviews.timeline_section.date_placeholder')}
    date={date}
    readonly={readonly}
    minDate={minDate || moment().toDate()}
    maxDate={maxDate}
    onChange={onChange}
    error={error}
    restrictToFutureTimes={restrictToFutureTimes}
  />
)
